import * as React from 'react';
import { useLocation, useNavigate } from 'react-router';
import AnonymousLayout from '../../layouts/AnonymousLayout';
import PasswordFormContainer from './PasswordFormContainer';
import './SetPassword.less';
import { clearApplicationStorage } from '../../../core/session';
import { getSetPasswordQueryStringsFromQueryOrLocalStorage } from '../../../core/domain';
import { Logo } from '../../../models/be/Branding';
import { getBrandingLogo } from '../../../core/customer';
import { useAsyncAction } from '../../../commonComponents/Hooks';
import { hasValue } from '../../../lib/utils';
import { getUserByEmail } from '../../../core/coreApi';

const SetPassword = () => {
	const location = useLocation();
	const navigate = useNavigate();

	clearApplicationStorage();

	const [secret, email, companyName] = getSetPasswordQueryStringsFromQueryOrLocalStorage(location);
	const [websiteLogo, setWebsiteLogo] = React.useState<Logo>();
	const [isUser, setIsUser] = React.useState<boolean>();
	const [, , performAsyncAction] = useAsyncAction(false);

	React.useEffect(() => {
		if (email) {
			performAsyncAction(async () => {
				const user = await getUserByEmail(email, null);
				setIsUser(hasValue(user.roleId));
			});
		}
	}, []);

	React.useEffect(() => {
		if (location.search.indexOf('secret') !== -1) {
			navigate(location.pathname);
		}
		getWebsiteLogo();
	}, []);

	const getWebsiteLogo = async () => {
		const logo = await getBrandingLogo();
		setWebsiteLogo(logo);
	};

	return (
		<AnonymousLayout title="Set Password" className="setPassword" logo={websiteLogo}>
			<PasswordFormContainer title="Set Password" email={email} secret={secret} navigate={navigate} isUser={isUser} />
			{companyName && (
				<p className="setPasswordText">
					{companyName} would like to perform background checks and they use VETTING.com to facilitate this process. Set
					a password so you can safely access your info.
				</p>
			)}
		</AnonymousLayout>
	);
};

export default SetPassword;
